import React, { createContext, ReactNode } from 'react';

export interface CheckoutDiscountContextProps {
  applyingDiscount: boolean;
  discountError: string | null;
  setDiscountError: (err: string | null) => void;
  handleApplyDiscount: (code: string) => Promise<void>;
  handleRemoveDiscount: (discountId: string) => Promise<void>;
}

const CheckoutDiscountContext = createContext<CheckoutDiscountContextProps | undefined>(undefined);

export const CheckoutDiscountProvider: React.FC<{
  children: ReactNode;
  value: CheckoutDiscountContextProps;
}> = ({ children, value }) => {
  return (
    <CheckoutDiscountContext.Provider value={value}>
      {children}
    </CheckoutDiscountContext.Provider>
  );
};

// useCheckoutDiscountContext is exported from ./useCheckoutDiscount to satisfy react-refresh/only-export-components

export default CheckoutDiscountContext;
